import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { initialState } from "./initial-state";
import { PBChangePayload, PoisBountySlice } from "./types";

export const poisBountyV3Slice = createSlice({
	name: "poisBounty/v3",
	initialState,
	reducers: {
		onPBV3change: (
			state,
			action: PayloadAction<PBChangePayload<PoisBountySlice>>
		) => {
			const { payload } = action;
			for (const [key, value] of Object.entries(payload)) {
				// @ts-expect-error
				state[key] = value;
			}
		}
	}
});

export const { onPBV3change } = poisBountyV3Slice.actions;

export const selectPoisBountyV3State = (state: RootState) => state.poisBountyV3;
export default poisBountyV3Slice.reducer;
